import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Portal from 'src/layout/Portal/Portal';
import useEventListener from 'src/hooks/useEventListener';
import { TModalFullScreen, TModalSize } from 'src/type/modal-type';
import Button, { IButtonProps } from 'src/components/bootstrap/Button';
import FormGroup from 'src/components/bootstrap/forms/FormGroup';
import Input from 'src/components/bootstrap/forms/Input';
import Select from 'src/components/bootstrap/forms/Select';
import Option from 'src/components/bootstrap/Option';
import { BsXCircleFill } from 'react-icons/bs';

export default function ModalUserBankEdit({
	isOpen,
	exit,
	data,
	handleSubmit,
	handleChangeData,
	bankList,
	t,
}) {
	return (
		<div>
			<Portal>
				<AnimatePresence mode='wait'>
					{isOpen && (
						<>
							<motion.div
								initial={{ scale: 0 }}
								animate={{ rotate: 0, scale: 1 }}
								transition={{
									type: 'spring',
									stiffness: 260,
									damping: 20,
								}}
								key='modal'
								className='modal show'
								style={{ display: 'block' }}
								tabIndex={-1}
								aria-hidden='true'>
								<div
									className='modal-dialog
										modal-dialog-scrollable
										modal-dialog-centered'>
									<div className='modal-content'>
										<div className='div_edit_bar'>
											<div className='fw-bold h5'>{t('txt_edit')}</div>
											<div className='div_exit' onClick={() => exit()}>
												<BsXCircleFill
													style={{ width: '15px', height: 'auto' }}
												/>
											</div>
										</div>
										<div className='div_edit_content'>
											<FormGroup label={t('txt_bank')}>
												<div className='div_select'>
													<Select
														style={{ height: '40px' }}
														ariaLabel='Status'
														name='bank_code'
														onChange={handleChangeData}
														value={data?.bank_name_th}>
														{bankList?.map((item) => {
															return (
																<Option
																	key={item}
																	value={item?.bank_code}>
																	{item?.bank_name_th}
																</Option>
															);
														})}
													</Select>
												</div>
											</FormGroup>
											<FormGroup
												label={t('txt_bank_nickname')}
												style={{ marginTop: '1rem' }}>
												<Input
													name='bank_nickname'
													placeholder=''
													className='input_search'
													type='text'
													value={data?.bank_nickname}
													onChange={handleChangeData}
												/>
											</FormGroup>

											<FormGroup
												label={t('txt_bank_account_name')}
												style={{ marginTop: '1rem' }}>
												<Input
													name='bank_account_name'
													placeholder=''
													className='input_search'
													type='text'
													value={data?.bank_account_name}
													onChange={handleChangeData}
												/>
											</FormGroup>

											<FormGroup
												label={t('txt_account_number')}
												style={{ marginTop: '1rem' }}>
												<Input
													name='bank_account_number'
													placeholder=''
													className='input_search'
													type='text'
													value={data?.bank_account_number}
													onChange={handleChangeData}
												/>
											</FormGroup>

											<Button
												onClick={handleSubmit}
												className='btn_save_edit'>
												<span>{t('txt_save')}</span>
											</Button>
										</div>
									</div>
								</div>
							</motion.div>
							<div className='modal-backdrop show'></div>
						</>
					)}
				</AnimatePresence>
			</Portal>
		</div>
	);
}
